import s from "./NoPortalAccess.module.scss"

type NoPortalAccessProps = {
  noAccessText: string
}
export const NoPortalAccess = ({ noAccessText }: NoPortalAccessProps) => (
  <div className={s.noPortalAccess}>{noAccessText}</div>
)
